export const GALLERY_IMAGE_PATH = "/gallery";
